import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'bxl-notfound',
  templateUrl: 'notfound.component.html',
})
export class NotfoundComponent implements OnInit {
  initialized = false;
  constructor() { }

  ngOnInit(): void {
    this.initialized = true;
  }
}
